import { Collateral, ObjectPropertyValues, DataObject as DataObjectModel } from '@sageworks/jpi';
import { ComponentDataHelper } from '../..//utils';
import { DataObject, FetchDataType } from '../../enums';
import { formatDataFieldIdKey } from '../..//components/form-components/simple-inputs/extended-field-helper';

export async function buildExistingCollateralResult(component: any, collateral: Collateral) {
	let dataObject: ObjectPropertyValues | null = null;
	if (collateral.id != null && collateral.id > 0) {
		dataObject = await ComponentDataHelper.fetchData<ObjectPropertyValues>(component, {
			fetchType: FetchDataType.DataObject,
			fetchContext: { type: DataObject.TypeEnum.Collateral, id: collateral.id }
		});
	}

	const data: any = { id: collateral.id };
	if (dataObject != null) {
		(dataObject.dataFieldValues ?? []).forEach(x => {
			if (x.id) {
				data[formatDataFieldIdKey(String(x.id))] = x.value;
			}
		});
	}
	return data;
}

export const getCollateralDataObjectsDetails = (dataObjects: {
	[p: string]: DataObjectModel[];
}): Array<{ type: DataObject.TypeEnum; dataObject: DataObjectModel }> | null => {
	return dataObjects[DataObject.TypeEnum.Collateral]
		? dataObjects[DataObject.TypeEnum.Collateral].map(dataObject => ({ type: DataObject.TypeEnum.Collateral, dataObject }))
		: null;
};
